var exports = {
  "kL": "AttachmentFile.module__container___TmZWZF",
  "G5": "AttachmentFile.module__deleteButton___TmZWZF",
  "Dq": "AttachmentFile.module__attachmentContainer___TmZWZF",
  "zc": "AttachmentFile.module__iconContainer___TmZWZF",
  "el": "AttachmentFile.module__fileInfoContainer___TmZWZF",
  "Md": "AttachmentFile.module__fileName___TmZWZF",
  "m$": "AttachmentFile.module__fileNameTruncate___TmZWZF",
  "i_": "AttachmentFile.module__fileExtension___TmZWZF",
  "Ov": "AttachmentFile.module__fileSize___TmZWZF",
  "l6": "AttachmentFile.module__downloadButton___TmZWZF",
  "Hj": "AttachmentFile.module__downloadButtonDisabled___TmZWZF",
};

module.exports = exports;
